export class SliderItemStyle {
  phonePortraitWidth = 'uk-width-1-1';
  phoneLandscapeWidth = 'uk-width-1-2@s';
  tabletLandscapeWidth = 'uk-width-1-3@m';
  desktopWidth = 'uk-width-1-3@l';
  largeScreensWidth = 'uk-width-1-4@xl';

  static normalize(styles: Partial<SliderItemStyle>): SliderItemStyle {
    const pureStyles = new SliderItemStyle();

    pureStyles.phonePortraitWidth = styles.phonePortraitWidth ?? pureStyles.phonePortraitWidth;
    pureStyles.phoneLandscapeWidth = styles.phoneLandscapeWidth ?? pureStyles.phoneLandscapeWidth;
    pureStyles.tabletLandscapeWidth = styles.tabletLandscapeWidth ?? pureStyles.tabletLandscapeWidth;
    pureStyles.desktopWidth = styles.desktopWidth ?? pureStyles.desktopWidth;
    pureStyles.largeScreensWidth = styles.largeScreensWidth ?? pureStyles.largeScreensWidth;

    return pureStyles;
  }
}
